import { createContext, useContext } from "react";

import type { TChannelSettings } from "@/models/channelSettings.model";

export type TSettingsContext = {
  settings: TChannelSettings | null;
};

export const SettingsContext = createContext<TSettingsContext | null>(null);

export const useSettings = () => {
  const settings = useContext(SettingsContext);

  if (!settings) {
    throw new Error("useSettings must be used within a SettingsContainer");
  }

  return settings;
};
